//Librairies
import styled from "styled-components";

//Styles
import { TitleSection } from "../styles/globalStyles";

//Images
import CardProject from "../components/CardProject";

const Project = () => {
  // Méthodes

  return (
    <Section id="projets">
      <TitleContainer>
        <TitleSection>PROJETS</TitleSection>
        <SubTitle>Mes derniers projets</SubTitle>
      </TitleContainer>
      <CardProject />
    </Section>
  );
};

const Section = styled.section`
  overflow: hidden;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  
`;

const TitleContainer = styled.section`
    position: relative;
`

const SubTitle = styled.section`
    position: absolute;
    top:50%;
    left:50%;
    transform: translate(-50%,-50%);
    font-family: 'Oswald';
    font-size: ${props => props.theme.fontlg};
    color:black;
    opacity: .5;
    white-space:nowrap;
`
export default Project;
